import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.2 13.2C17.6103 13.2 17.9484 13.5088 17.9946 13.9067L18 14V15.6C18 16.8781 17.0009 17.9229 15.741 17.9959L15.6 18H4.4C3.12186 18 2.07707 17.0009 2.00407 15.741L2 15.6V14C2 13.5582 2.35817 13.2 2.8 13.2C3.21027 13.2 3.54841 13.5088 3.59462 13.9067L3.6 14V15.6C3.6 16.0103 3.90883 16.3484 4.3067 16.3946L4.4 16.4H15.6C16.0103 16.4 16.3484 16.0912 16.3946 15.6933L16.4 15.6V14C16.4 13.5582 16.7582 13.2 17.2 13.2ZM9.88123 2.00881L9.92798 2.0032L10 2L10.0602 2.00223L10.1606 2.01619L10.2497 2.03979L10.3386 2.07494L10.4166 2.1168L10.5004 2.17575L10.5657 2.23431L12.9657 4.63431C13.2781 4.94673 13.2781 5.45327 12.9657 5.76569C12.6533 6.0781 12.1467 6.0781 11.8343 5.76569L10.8 4.7312V12.4C10.8 12.8418 10.4418 13.2 10 13.2C9.55817 13.2 9.2 12.8418 9.2 12.4V4.7312L8.16569 5.76569C7.85327 6.0781 7.34673 6.0781 7.03431 5.76569C6.7219 5.45327 6.7219 4.94673 7.03431 4.63431L9.43431 2.23431C9.46263 2.206 9.49254 2.18025 9.52376 2.15707L9.61275 2.09974L9.70293 2.05698L9.78721 2.02868L9.88123 2.00881Z",
		fill: "currentColor"
	})
});
export default SvgUpload;
